// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__2uBhK","label":"Category_label__-9Agu","content":"Category_content__2joEI","header":"Category_header__2bDyq","location":"Category_location__15Ga5"};